export const seriesData = ["1-Serie", "2-Serie", "3-Serie", "4-Serie", "5-Serie", "X1", "X2", "X3", "X5", "iX"]
export const carouselData = ["1", "2", "3", "4", "5", "X1", "X2", "X3", "X5", "iX"];

export default seriesData;
